
import NewOrganizationForm from "./NewOrganizationForm";
import { OrganizationDetails } from "@/types/assessment";
import { useAuth } from "@/contexts/AuthContext";

interface OrganizationDetailsStepProps {
  onSubmit: (details: OrganizationDetails) => void;
}

export const OrganizationDetailsStep = ({ onSubmit }: OrganizationDetailsStepProps) => {
  const { user } = useAuth();

  const handleOrganizationSubmitWithUser = (details: OrganizationDetails) => {
    if (user) {
      const updatedDetails = {
        ...details,
        assessorEmail: user.email,
        assessorName: details.assessorName || user.fullName
      };
      onSubmit(updatedDetails);
    } else {
      onSubmit(details);
    }
  };

  return <NewOrganizationForm onSubmit={handleOrganizationSubmitWithUser} />;
};
